import { isNotNil } from '@flowio/is';
import keys from './keys';

export default function filterObjectNils<T extends {}>(obj:T): T {
  return keys(obj).reduce<T>((acc, key) => {
    if (isNotNil(obj[key])) {
      acc[key] = obj[key];
    }
    return acc;
  }, {} as T);
}
